import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  'title',
  'body_summary',
  'field_department_name',
  'field_website_filter_name',
  'field_address_name',
  'field_employment_type_name',
];

export const resultAttributes = [
  'url',
  'body',
  'field_department_name',
  'field_website_filter_name',
  'field_employment_type_name',
  'field_address_name',
  'field_function',
  'title',
  'nid',
  'body_summary',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'department',
    field: 'field_department_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'address',
    field: 'field_address_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'website_filter',
    field: 'field_website_filter_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: '_score',
    order: 'desc',
  },
  _title_asc: {
    field: 'title',
    order: 'asc',
  },
  _title_desc: {
    field: 'title',
    order: 'desc',
  },
};
